export const FINANCING_EVENTS = {
  INPUT_VALIDATION: 'financing.field_validation',
  CALCULATE_PAYMENTS: 'financing.calculate_payment',
  PAYMENT_LIST_PIXEL: 'financing.payment_list_pixel',
  NEXT_STEP_BTN: 'financing.next_step',
  SAVE_VEHICLE: 'financing.save_vehicle',
  BACK_BTN: 'financing.click_back_button',
  LEAD_FORM_ATTEMPT_SUBMIT: 'financing.lead_form_attempt_submit',
  LEAD_FORM_PROCESSED_SUBMIT: 'financing.lead_form_processed_submit',
  LEAD_FORM_SUBMIT: 'financing.lead_form_submit',
  DISPLAY_LEAD_FORM: 'financing.display_lead_form',
  DISPLAY_THANK_YOU: 'financing.display_thank_you',
  SEND_CONFIRMATION_EMAIL: 'financing.send_confirmation_email',
  COUNTER_TRIGGER: 'financing.counter_trigger',
  SEND_CONSUMER_EMAIL: 'financing.send_consumer_email',
  DISPLAY_EMAIL_INPUT: 'financing.display_email_input',
  SAVE_EMAIL_EVENT: 'financing.save_email_event',
  LIST_PIXEL: 'financing.list_pixel',
  VIN_CONFIRMATION: 'financing.vin_confirmation',
  CONFIRMATION_CTA_CLICK: 'financing.confirmation_cta_click',
  LOOK_IT_UP_CLICK: 'financing.look_it_up',
  WIDGET_VIEW: 'financing.widget_view',
  CONFIRM_CLICK: 'financing.confirm_click',
  EDIT_CONFIRM_CLICK: 'financing.edit_confirm_click',
  INPUT_VALUE: 'financing.input_value',
  API_SYSTEM_ERROR: 'financing.api_system_error',
  API_SYSTEM_ERROR_V2: 'financing.api_system_error_v2',
  PREQUAL_NEWAPP_APPROVAL: 'financing.prequal_newapp_approval',
  ZIP_INPUT_VALUE: 'financing.zip_input_value',
  LIST_PIXEL_POSTPREQUAL: 'financing.list_pixel_postprequal',
  CALCULATE_PAYMENT_POSTPREQUAL: 'financing.calculate_payment_postprequal',
  WIDGET_VIEW_PHOTOFLIPPER: 'financing.widget_view_photoflipper',
  FEES_DISCLAIMER: 'financing.fees_disclaimer',
};
